const YesNoNode = require('../YesNoNode');
const Q_slowed = require('./Q_slowed');
const UseAbility = require('../UseAbility');
const BattleCalc = require('../../BattleCalc');

const Q_scared = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.YES] = new Q_slowed(actor, battleState);

  if (BattleCalc.getEquippedAbility(actor, 'road_to_nowhere')) {
    node.branches[node.NO] = new UseAbility({
      actor,
      abilityHandle: 'road_to_nowhere',
      altNode: node.branches[node.YES],
    });
  } else {
    node.branches[node.NO] = node.branches[node.YES];
  }

  node.yesNoEvalFunction = function (target) {
    return (
      BattleCalc.getCondition(target, 'scared') ||
      BattleCalc.getCondition(target, 'unshakeable')
    );
  };

  return node;
};
module.exports = Q_scared;
